export enum DtModelFormatEnum {
	DXF = 'DXF',
	GLB = 'GLB',
	GLTF = 'GLTF',
	IFC = 'IFC',
	JPEG = 'JPEG',
	PDF = 'PDF',
	ZIP = 'ZIP',
	PNG = 'PNG',
}
